import React from "react";
import { observer, inject } from "mobx-react";
import styled from "styled-components";
import _ from "lodash";

import { Box, Text } from "grommet";
import { Offline, Online } from "react-detect-offline";
import { Globe, Connect } from "grommet-icons";

import Book from "app/api/book";
/*OEF ToC/SECTION MODs*/

const Context = styled(Box)`
  position: fixed;
  bottom: 70px;
  left: 50%;
  transform: translateX(-50%);
  max-width: 768px;
  width: 100%;
  z-index: 9;
  @media (max-width: 600px) {
    bottom: 50px;
  }
`;

const Bar = styled(Box)`
  position: fixed;
  bottom: 0;
  left: 50%;
  transform: translateX(-50%);
  min-height: 70px !important;
  height: 70px !important;
  max-height: 70px !important;
  z-index: 9;
  @media (max-width: 600px) {
    min-height: 50px !important;
    height: 50px !important;
    max-height: 50px !important;
  }
`;

const OnlineContainer = styled.span`
  width: 24px;
  height: 24px;
`;

function MenuBar({ AppState, children }) {
  //MAR 21 By RR changed declaration from const to let
  let context = _.chain(AppState.selectedSection)
    .drop()
    .filter(_.isString)
    .map(_.startCase)
    .join(" / ")
    .value();
  //DEBUG: console.log(`CONTEXT ${context}`);
  //check if section, convert to uppercase
  if (_.includes(context, "Section")) {
    context = _.toUpper(context);
  }

  return (
    <React.Fragment>
      {!AppState.isUserAnnotating && (
        <Context
          direction="row"
          alignContent="center"
          justify="between"
          pad={{ horizontal: "small" }}
          background="dark-5"
        >
          <Text color="focus" weight="bold">
            {`${Book.metadata.title} / ${context}`}
          </Text>
          <Online polling={false} url={"https://google.com"}>
            <OnlineContainer title="ONLINE">
              <Globe color="status-ok" />
            </OnlineContainer>
          </Online>
          <Offline polling={false} url={"https://google.com"}>
            <Box
              direction="row"
              alignContent="center"
              align="center"
              gap="small"
            >
              <Text weight="bold" color="white">
                OFFLINE
              </Text>
              <Connect color="white" />
            </Box>
          </Offline>
        </Context>
      )}
      <Bar
        tag="nav"
        justify="between"
        align="center"
        direction="row"
        background="brand"
        overflow="hidden"
        width="large"
        pad={{ horizontal: "medium" }}
      >
        {children}
      </Bar>
    </React.Fragment>
  );
}

export default inject("AppState")(observer(MenuBar));



// WEBPACK FOOTER //
// ./src/app/components/Menu/MenuBar.js